"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syllableToChar = void 0;
var JamoConstants_1 = require("../JamoConstants");
/**
 * 초성, 중성, 종성을 모아 음절로 완성한다.
 * @param syllable 조립형 음절
 * @returns 완성형 음절
 */
function syllableToChar(syllable) {
    if (isEmpty(syllable))
        return "";
    if (isOnlyInitalCosonat(syllable))
        return syllable.initialConsonat;
    if (isOnlyMediaVowel(syllable))
        return syllable.medialVowel;
    if (isOnlyFinalConsonat(syllable))
        return syllable.finalConsonat;
    var hangulFirstIndex = "가".charCodeAt(0);
    var emptyCharCount = 1;
    var jongseongLength = JamoConstants_1.JamoConstants.finalConsonats.length + emptyCharCount;
    if (syllable.initialConsonat && syllable.medialVowel) {
        var choseongIdx = JamoConstants_1.JamoConstants.initialConsonants.indexOf(syllable.initialConsonat) *
            JamoConstants_1.JamoConstants.medialVowels.length *
            jongseongLength;
        var jungseongIdx = JamoConstants_1.JamoConstants.medialVowels.indexOf(syllable.medialVowel) *
            jongseongLength;
        var jongseongIdx = syllable.finalConsonat
            ? JamoConstants_1.JamoConstants.finalConsonats.indexOf(syllable.finalConsonat) +
                emptyCharCount
            : 0;
        return String.fromCharCode(hangulFirstIndex + choseongIdx + jungseongIdx + jongseongIdx);
    }
    throw new Error("'" + syllable.initialConsonat + "','" + syllable.medialVowel + "','" + syllable.finalConsonat + "' \uB294 \uD55C\uAE00 \uC74C\uC808\uB85C \uBCC0\uD658\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
}
exports.syllableToChar = syllableToChar;
function isOnlyFinalConsonat(syllable) {
    return (!syllable.initialConsonat && !syllable.medialVowel && syllable.finalConsonat);
}
function isOnlyMediaVowel(syllable) {
    return (!syllable.initialConsonat && syllable.medialVowel && !syllable.finalConsonat);
}
function isOnlyInitalCosonat(syllable) {
    return (syllable.initialConsonat && !syllable.medialVowel && !syllable.finalConsonat);
}
function isEmpty(syllable) {
    return (!syllable.initialConsonat &&
        !syllable.medialVowel &&
        !syllable.finalConsonat);
}
